import { IconButton as MuiIconBtn, IconButtonProps } from '@mui/material';
import { FunctionComponent } from 'react';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Icon } from 'shared/ui/Icon';

interface Props extends IconButtonProps {
	iconId: string;
}

export const SmallIconButton: FunctionComponent<Props> = ({ sx, onClick, iconId }) => {
	return (
		<MuiIconBtn
			sx={{
				'display': 'flex',
				'alignItems': 'center',
				'justifyContent': 'center',
				'width': '20px',
				'height': '20px',
				'padding': 0,
				'boxSizing': 'content-box',
				'border': `5px solid ${ColorPalette.catskillWhite}`,
				'backgroundColor': ColorPalette.royalBlue,
				'&:hover': {
					backgroundColor: ColorPalette.royalBlue,
				},
				...sx,
			}}
			onClick={onClick}
		>
			<Icon
				id={iconId}
				style={{
					width: '15px',
					height: '15px',
					marginLeft: '1px',
					color: ColorPalette.white,
					transform: 'rotate(90deg) translateY(0.5px)',
				}}
			/>
		</MuiIconBtn>
	);
};
